import { v4 as uuid } from 'uuid';

import { env } from '../res';

/**
 * Generates an unique correlation vector for a given error to be reported
 * @param source The source of the CID
 */
export const generateCid = (source: string) => `${source}${uuid()}${env.rtdVersion}`;
